// extracted by mini-css-extract-plugin
export default {"button_box":"ControlInsTable_button_box__Ml612","listCon":"ControlInsTable_listCon__vZe82","table_box":"ControlInsTable_table_box__d8uZC"};